module.exports = __webpack_public_path__ + "img/20190702161552646.a5263758.png";